import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: () =>
            import ('../pages/index.vue'),
    }, {
        path: '/index',
        name: '',
        component: () =>
            import ('../pages/index.vue'),
    }, {
        path: '/upload',
        name: '',
        component: () =>
            import ('../pages/upload.vue'),
    }, {
        path: '/review',
        name: '',
        component: () =>
            import ('../pages/review.vue'),
    }, {
        path: '/form',
        name: '',
        component: () =>
            import ('../pages/form.vue'),
    }, {
        path: '/amza',
        name: '',
        component: () =>
            import ('../pages/amazon-a.vue'),
    }, {
        path: '/amzb',
        name: '',
        component: () =>
            import ('../pages/amazon-b.vue'),
    }, {
        path: '/join',
        name: '',
        component: () =>
            import ('../pages/join.vue'),
    }, {
        path: '/thanks',
        name: '',
        component: () =>
            import ('../pages/thanks.vue'),
    },

      /* contact-us */
      {
        path: '/contact-us',
        name: '',
        component: () =>
          import ('../pages/contact-us/index.vue'),
      },
      {
        path: '/pre-sales-inquiry',
        name: '',
        component: () =>
          import ('../pages/contact-us/pre-sales-inquiry.vue'),
      },
      {
        path: '/after-sales-inquiry',
        name: '',
        component: () =>
          import ('../pages/contact-us/after-sales-inquiry.vue'),
      },
      {
        path: '/submitted',
        name: '',
        component: () =>
          import ('../pages/contact-us/submitted.vue'),
      },



      /* warranty-policy */
      {
        path: '/warranty-policy',
        name: 'WarrantyPolicyIndex',
        component: () =>
          import ('../pages/warranty-policy/index.vue'),
      },
      {
        path: '/warranty-claim',
        name: 'WarrantyClaim',
        component: () =>
          import ('../pages/warranty-policy/warranty-claim.vue'),
      },

      /* return-refund-policy */
      {
        path: '/return-refund-policy',
        name: 'ReturnRefundPolicy',
        component: () =>
          import ('../pages/return-refund-policy/index.vue'),
      },
      {
        path: '/cancel-order',
        name: 'CancelOrder',
        component: () =>
          import ('../pages/return-refund-policy/cancel-order.vue'),
      },
      {
        path: '/start-a-return',
        name: 'StartAReturn',
        component: () =>
          import ('../pages/return-refund-policy/start-a-return.vue'),
      },

      /* FAQs */
      {
        path: '/faqs',
        name: 'FAQs',
        component: () =>
          import ('../pages/faqs/index.vue'),
      },

      /*track-my-order*/
      {
        path: '/track-my-order',
        name: 'TrackMyOrder',
        component: () =>
          import ('../pages/track-my-order/index.vue'),
      },

      /*shipping-policy*/
      {
        path: '/shipping-policy',
        name: 'ShippingPolicy',
        component: () =>
          import ('../pages/shipping-policy/index.vue'),
      },
      // package-protection
      // {
      //   path: '/package-protection',
      //   name: 'PackageProtection',
      //   component: () =>
      //     import ('../pages/package-protection/index.vue'),
      // },
      {
        path: '/package-protection-claim',
        name: 'PackageProtectionClaim',
        component: () =>
          import ('../pages/package-protection/package-protection-claim.vue'),
      }

    ]
})


// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}





// WEBPACK FOOTER //
// ./src/router/index.js